module.exports = __webpack_public_path__ + "static/media/edit-active-ic.83152642.svg";